import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SearchableInnerWrapper, SearchableInput, SearchableWrapper, } from './BKJSelectSearch.styled.js';
import { BKJIcon } from '../BKJIcon/index.js';
export const BKJSelectSearch = ({ placeholder, name, value, onChange, ...rest }) => {
    return (_jsx(SearchableWrapper, { children: _jsxs(SearchableInnerWrapper, { children: [_jsx(BKJIcon, { iconName: "Search", fontSize: 18 }), _jsx(SearchableInput, { name: name, onChange: onChange, value: value, placeholder: placeholder, ...rest })] }) }));
};
//# sourceMappingURL=BKJSelectSearch.js.map